const REALM_FLAG_BY_DOMAIN: Record<string, string> = {
  'saudiarabia.cogia.chat': 'twemoji:flag-saudi-arabia',
  'italy.cogia.chat': 'twemoji:flag-italy',
  'ghana.cogia.chat': 'twemoji:flag-ghana',
  'burkinafaso.cogia.chat': 'twemoji:flag-burkina-faso',
}

export const DEFAULT_REALM_LOGO = 'gridicons:domains'

export const getRealmLogo = (domain: string): string => REALM_FLAG_BY_DOMAIN[domain] || DEFAULT_REALM_LOGO
